<section class="ib-switch-sell-hotel-card">
    <header class="ib-switch-sell-hotel-card__header">
        <img [src]="currentImg" class="ib-switch-sell-hotel-card__logo" />
    </header>
    <div class="ib-switch-sell-hotel-card__main">
        <div class="ib-switch-sell-hotel-card__info">
            <div class="ib-switch-sell-hotel-card__info__rating">
                <span *ngFor="let _ of hotelStarRating" class="ib-switch-sell-hotel-card__info__rating__star"></span>
            </div>
            <h1 class="ib-switch-sell-hotel-card__info__title">{{ switchSellHotelData.name }}</h1>
            <!-- <h6 class="ib-switch-sell-hotel-card__info__subtitle">
                {{ switchSellHotelData.name }}
            </h6> -->
            <div class="ib-switch-sell-hotel-card__info__feature">
                <img src="/iberia-web-content/imagenes/switch-sell/check.png"
                    class="ib-switch-sell-hotel-card__info__feature__icon" alt="" />
                <p class="ib-switch-sell-hotel-card__info__feature__text">
                    {{'ALP_SWITCH_SELL_HOTEL_CONDITION_TXT_1'|translate}}
                </p>
            </div>
        </div>

        <div class="ib-switch-sell-hotel-card__price">
            <h4 class="ib-switch-sell-hotel-card__price__package">
                {{'ALP_SWITCH_SELL_HOTEL_SUBTXT'|translate}}
                <span class="ib-switch-sell-hotel-card__price__package__savings">
                    {{savingPrice}}
                </span>
            </h4>
            <h1 class="ib-switch-sell-hotel-card__price__total">{{switchSellHotelData.amount | customCurrency: switchSellHotelData.currency}}</h1>
            <p class="ib-switch-sell-hotel-card__price__description">
                {{'ALP_SWITCH_SELL_PRICE_TXT_3'|translate}}
            </p>
        </div>

        <button (click)="redirectToIbh()" class="ib-switch-sell-hotel-card__button">
            {{'ALP_SWITCH_SELL_HOTEL_BTN'|translate}}
        </button>
    </div>
</section>